import type { AgentLog } from './planningRuntimeApi';

function logTimestamp(value: string): number {
  const normalized = value.endsWith('Z') || value.includes('+') ? value : `${value}Z`;
  const timestamp = new Date(normalized).getTime();

  return Number.isNaN(timestamp) ? 0 : timestamp;
}

export function mergeAgentLogs(current: AgentLog[], incoming: AgentLog[]): AgentLog[] {
  const byId = new Map<string, AgentLog>();

  [...current, ...incoming].forEach((log) => {
    const existing = byId.get(log.id);
    const definedFields = Object.fromEntries(
      Object.entries(log).filter(([, value]) => value !== undefined),
    ) as unknown as AgentLog;

    byId.set(log.id, existing ? { ...existing, ...definedFields } : definedFields);
  });

  return Array.from(byId.values())
    .sort((left, right) => logTimestamp(right.created_at) - logTimestamp(left.created_at))
    .slice(0, 100);
}
